import { scaffoldEdit } from "common/scaffolding/reducers/scaffoldEdit";
import { EditableMembershipLevel, MembershipLevelSummary } from "../types";

export enum TypeKeys {
    FETCH_BEGIN = "MEMBERSHIPLEVEL/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "MEMBERSHIPLEVEL/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "MEMBERSHIPLEVEL/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "MEMBERSHIPLEVEL/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "MEMBERSHIPLEVEL/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "MEMBERSHIPLEVEL/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableMembershipLevel, MembershipLevelSummary, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };

export type SavedAction = ReturnType<typeof createAction.saved>;
